export const CONFIRMATION_MODAL_CONSTS = {
  areYouSure: 'Вы действительно хотите',
  warning: 'Внимание!'
}
